module.exports = __webpack_public_path__ + "static/img/nodata.d406301.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/nodata.png
// module id = yAZ9
// module chunks = 6